let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bxrJM")).then(() => parcelRequire('6A8Au'));